module.exports = __webpack_public_path__ + "static/media/BOU.951da0ca.apng";